/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki.js.map